// 3rd party imports
import * as React from 'react';
import { Redirect, Route } from 'react-router';
import { observer } from 'mobx-react';

// mobx
import { AuthState } from 'sources';

// components
import { RenderWrapper } from './render-wrapper';
import { useStores } from 'hooks';

interface IProgramRelationshipAuthorizedRouteProps {
  path: string;
  redirectPath: string;
  component: any;
  render?: any;
  requireAuthorization: boolean;
}

export const SecureRoute: React.FunctionComponent<IProgramRelationshipAuthorizedRouteProps> = observer(
  // tslint:disable-next-line:no-shadowed-variable
  function SecureRoute({ path, redirectPath, component, render, requireAuthorization }) {
    const { context, userAuth, analytics, user } = useStores();

    const createRenderWrapper = () => {
      return <RenderWrapper component={component} render={render} />;
    };

    const renderAuthenticated = () => {
      // If we have a crashed session, this will give a blank page. :-/
      if (userAuth.authenticated === AuthState.UNKNOWN) {
        return null;
      }

      return <Route path={path} render={createRenderWrapper} />;
    };

    const renderAuthorized = () => {
      if (userAuth.authenticated === AuthState.UNKNOWN || userAuth.authorized === AuthState.UNKNOWN) {
        return null;
      }

      if (userAuth.authenticated === AuthState.TRUE && userAuth.authorized === AuthState.TRUE) {
        return <Route path={path} render={createRenderWrapper} />;
      }

      return <Redirect to={redirectPath} />;
    };

    if (!requireAuthorization) {
      return renderAuthenticated();
    }

    return renderAuthorized();
  },
);
